"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerRosterPersonaFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
exports.triggerRosterPersonaFactory = Factory.Sync.makeFactory({
    _links: [],
    roster_persona_id: Factory.each(i => uuid_1.v4()),
    nickname: 'Mud',
    roster_role: 'player',
    persona: { _links: [], persona_id: '45' },
});
